import * as React from 'react';

import { Button } from '@cian/ui-kit';
import { UIText1, UIText2 } from '@cian/ui-kit/typography';
import { ConditionalWrapper } from '@cian/conditional-component';
import { CircularProgressBar } from '../packages/CircularProgressBar';

import * as styles from './styles.css';

export interface ICounterBannerRealtorsProps {
  text: string;
  count: number;
  maxCount: number;
  progressPercentage: number;
  isMobile: boolean;
  onClick: () => void;
}

export const CounterBannerRealtors: React.FC<React.PropsWithChildren<ICounterBannerRealtorsProps>> = ({
  count,
  maxCount,
  progressPercentage,
  text,
  isMobile,
  onClick,
}) => {
  const circleSize = isMobile ? 12 : 18;

  return (
    <div className={styles['wrapper']}>
      <div className={styles['progress-bar']}>
        <CircularProgressBar
          count={count}
          maxCount={maxCount}
          progressPercentage={progressPercentage}
          strokeWidth={4}
          size={circleSize}
        />
      </div>
      <ConditionalWrapper if={isMobile} ThenComponent={UIText2} ElseComponent={UIText1}>
        {text}
      </ConditionalWrapper>
      <div className={styles['button']}>
        <Button size="XS" theme="fill_primary" onClick={onClick} fullWidth disabled={Boolean(!count)}>
          Отправить заявку
        </Button>
      </div>
    </div>
  );
};

CounterBannerRealtors.displayName = 'CounterBannerRealtors';
